<template>
  <input
    v-bind="$attrs"
    v-model="model"
    class="flex-1 min-w-0 leading-tight rounded-md border border-gray-450 aria-[invalid=true]:border-red-500 disabled:border-gray-350 focus:border-blue-400 shadow-inset bg-white focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-600 placeholder:text-gray-600 placeholder:italic transition-colors duration-100 ease-out"
    :class="{
      'px-3.5 py-2.5': size === 'lg' || size === 'md',
      'px-3 py-2': size === 'sm',
      'px-2.5 py-1.5': size === 'xs',
      '': size === 'custom',
    }"
  />
</template>
<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
});

const model = defineModel();

export type Size = 'custom' | 'xs' | 'sm' | 'md' | 'lg';

const {size = 'md'} = defineProps<{
  size?: Size;
}>();
</script>
<style scoped>
/* Hide the native date/time picker button in Chromium/Safari so only our custom
   picker button shows. Firefox has no equivalent pseudo-element; there it's hidden
   by SInputField.vue's picker button, which overlays the input's right edge. */
input[type='date']::-webkit-calendar-picker-indicator,
input[type='time']::-webkit-calendar-picker-indicator {
  display: none;
}
input[type='date'],
input[type='time'] {
  appearance: none;
  /* Date/time inputs default to the arrow cursor in the UA stylesheet; use the
     text cursor so they feel consistent with our other text fields. */
  cursor: text;
}
</style>
